import { toast } from 'react-toastify';

// booking / listing type -> details page path (trip, camp, act, gu)
const DETAILS_PATH = {
    trip: 'trip',
    camp: 'camp',
    stay: 'camp',
    act: 'act',
    activity: 'act',
    gu: 'gu',
    guide: 'gu',
    ayur: 'ayur'
};

export const SHARE_LABEL = {
    trip: 'Trip',
    camp: 'Camp',
    act: 'Activity',
    gu: 'Guide'
};

// share(e, id, type, title) — type picks the details page the link opens
export const share = async (e, id, type = 'trip', title) => {
    e?.stopPropagation?.();
    if (!id) return;
    const path = DETAILS_PATH[type] || 'trip';
    const url = `${window.location.origin}/${path}/details/${id}`;
    if (navigator.share) {
        try {
            await navigator.share({
                title: title || 'Check this out!',
                text: title ? `Check out ${title} on Trvto` : 'Here is something cool I wanted to share with you.',
                url
            });
        } catch (error) {
            // closing the share sheet is not an error worth showing
            if (error?.name !== 'AbortError') console.error('Error sharing:', error);
        }
        return;
    }
    // browsers without the share sheet: copy the link instead
    try {
        await navigator.clipboard.writeText(url);
        toast.success('Link copied');
    } catch {
        toast.info(url);
    }
};
